module.exports = __webpack_public_path__ + "img/footerBg.eeb32974.png";